import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=37beba1e&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=37beba1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37beba1e",
  null
  
)

export default component.exports